import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addCartItem } from "@/store/cart";
import { useGlobalStore } from "@/store/global";
import { useModalStore } from "@/store/modal";
import { useVariantsStore } from "@/store/variants";
import AddToCart, { CartTresholdExceeded } from "../../cart/add-to-cart";
import { isSellable, countDecimals } from "../utils";
import { useProductStore } from "@/store/product";
import { DebounceInput } from 'react-debounce-input';
export default function ProductQuantity({ ...product }) {
    const texts = useGlobalStore((state) => state.config.texts);
    const selectedVariant = useVariantsStore((state) => state.selectedVariant);
    let selectedQuantity = useVariantsStore((state) => state.selectedQuantity);
    const setSelectedQuantity = useVariantsStore((state) => state.setSelectedQuantity);
    const selectedServices = useProductStore((state) => state.selectedServices);
    const variants = useVariantsStore((state) => state.variants);
    const open = useModalStore((state) => state.open);
    const close = useModalStore((state) => state.close);
    const api = useGlobalStore((state) => state.config.api);
    const decimalPlaces = countDecimals(product.custom_quantity);
    const sellable = isSellable(selectedVariant ? selectedVariant : product, selectedQuantity);
    const disabled = !sellable || ((variants?.length || 0) > 0 && !selectedVariant);
    function handleChangeQuantity(value, input = false) {
        if (!value) {
            value = 0;
        }
        let newValue = selectedQuantity + value;
        if (input) {
            newValue = Math.ceil(value / product.custom_quantity);
        }
        if (newValue <= 0) {
            setSelectedQuantity(1);
        }
        else {
            const stock = selectedVariant ?? product;
            const sellableNext = isSellable(stock, newValue);
            if (!sellableNext && stock.quantity > 0) {
                open({
                    title: "",
                    content: (_jsx(CartTresholdExceeded, { quantityTreshold: (stock.quantity * product.custom_quantity).toFixed(decimalPlaces), unit: product.unit })),
                });
                setSelectedQuantity(stock.quantity);
            }
            else if (sellableNext) {
                setSelectedQuantity(newValue);
            }
        }
    }
    async function handleAddToCard() {
        try {
            await addCartItem(api.cart.add, product.id, selectedQuantity, selectedVariant?.id, selectedServices);
            open({
                title: texts["text342"],
                content: _jsx(AddToCart, { ...product }),
            });
        }
        catch (err) {
            console.error(err);
            open({
                title: texts["text530"],
                content: (_jsx("button", { className: "primary mt-4", onClick: () => close(), children: texts["text272"] })),
            });
        }
    }
    return (_jsxs("div", { className: "add-to-cart d-flex align-items-center", children: [_jsx("button", { onClick: () => handleChangeQuantity(-1), className: "quantity", disabled: disabled, children: _jsx("span", { className: "minus" }) }), _jsx(DebounceInput, { minLength: 1, debounceTimeout: 750, onChange: (e) => handleChangeQuantity(e.target.valueAsNumber, true), className: "ml-1", style: { maxWidth: "6rem" }, type: "number", value: sellable
                    ? (selectedQuantity * product.custom_quantity).toFixed(decimalPlaces)
                    : 0, disabled: disabled }), _jsx("button", { onClick: () => handleChangeQuantity(1), className: "quantity ml-1", disabled: disabled, children: _jsx("span", { className: "plus" }) }), _jsxs("button", { onClick: handleAddToCard, className: "primary ml-2", disabled: disabled, children: [_jsx("i", { className: "fa-solid fa-cart-shopping mr-2" }), texts["text227"]] })] }));
}
